export default "__VITE_PUBLIC_ASSET__13830cda__"